<template>
    <div class="nav-container">
        <gameOption />
        <div class="navbar">
            <div class="navbar-item" :class="{ 'active': p.isActive }" v-for="p in pages" :key="p.id"
                @click="() => $router.push({ path: p.path, query: $route.query })">
                <p>{{ p.name }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import gameOption from "./game-option.vue";

export default {
    components: { gameOption },
    mixins: [languageMixins],
    data() {
        return {
            pages: [
                {
                    id: 1,
                    name: this.getTranslatedText(`next up`),
                    path: "/",
                    routeName: "next-up",
                    isActive: false,
                },
                {
                    id: 2,
                    name: this.getTranslatedText(`today racing`),
                    path: "/racing",
                    routeName: "racing",
                    isActive: false,
                },
                {
                    id: 3,
                    name: this.getTranslatedText(`today result`),
                    path: "/result",
                    routeName: "result",
                    isActive: false,
                },
                {
                    id: 4,
                    name: this.getTranslatedText(`history`),
                    path: "/history",
                    routeName: "history",
                    isActive: false,
                }
            ],
        };
    },

    created() {
        this.updateActivePage();
    },

    watch: {
        '$route': {
            handler() {
                this.updateActivePage();
            },
            immediate: true
        }
    },

    methods: {
        updateActivePage() {
            const { path, name } = this.$route;
            const routeNameToNavItem = {
                'next-up': 'next-up',
                'racing': 'racing',
                'racing-detail': 'racing',
                'result': 'result',
                'result-detail': 'result',
                'history': 'history',
                'history-detail': 'history'
            };

            let activeRouteName = routeNameToNavItem[name] || null;

            if (!activeRouteName) {
                if (path === '/' || path.startsWith('/?')) {
                    activeRouteName = 'next-up';
                } else if (path.startsWith('/racing')) {
                    activeRouteName = 'racing';
                } else if (path.startsWith('/result')) {
                    activeRouteName = 'result';
                } else if (path.startsWith('/history')) {
                    activeRouteName = 'history';
                }
            }

            this.pages.forEach((page) => {
                page.isActive = page.routeName === activeRouteName;
            });
        },
    },
};
</script>

<style lang="scss">
@import "@/public/scss/components/common/navbar/vertical-navbar.scss";
</style>